<template>
  <fieldset class="step"></fieldset>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import debounce from "debounce";

export default {
  name: "BaseCertificationFormStep",
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    v: {
      type: Object,
      default: () => {}
    },
    history: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: this.value
    };
  },
  computed: {
    ...mapState("Form", { formDisabled: "formDisabled" }),
    stepTitle() {
      return this.$t(`${this.$store.getters["Form/title"]}`);
    }
  },
  watch: {
    value: {
      handler: function(newValue) {
        this.form = newValue;
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    editComment(e) {},
    touch(validator) {
      validator && validator.$touch && validator.$touch();
    }
  }
};
</script>

<style lang="scss">
.step {
}
</style>
